import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHandcycleNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M27.5 14.67a4.337 4.337 0 00-3.262 1.493l-5.25-2.8A1.5 1.5 0 1017.5 15a1.48 1.48 0 00.71-.186l3.53 1.886-.86 1.47h-6.73a1.492 1.492 0 01-1.32-.79l-2.42-4.55H8.55l2.83 5.33c.074.141.161.275.26.4a3.1 3.1 0 002.51 1.27h7.68l1.361-2.351.22.119a4.09 4.09 0 00-.24 1.402 4.33 4.33 0 104.33-4.33zm0 7a2.67 2.67 0 01-2.6-3.277l2.63 1.407v-1.88l-1.77-.94a2.6 2.6 0 011.74-.65 2.67 2.67 0 010 5.34zm-23 1.66a4.344 4.344 0 004.25-3.5h1.69l-.88-1.66h-.81a4.33 4.33 0 10-4.25 5.16zm0-7a2.667 2.667 0 012.54 1.84H4.26v1.66h2.78a2.67 2.67 0 11-2.54-3.5z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsHandcycleNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHandcycleNormalMedium;
